import type { CSSProperties } from 'react';
import type { Comment, CommentStatus } from '../lib/types';

const WIDTH = 320;
const HEIGHT = 170; // typical height; used only to decide whether to flip upward

/** Where to put the composer so it stays inside `bounds` next to point (x, y). */
export function composerPosition(x: number, y: number, bounds: { width: number; height: number }): CSSProperties {
  const gap = 20;
  const left = x + gap + WIDTH > bounds.width ? Math.max(8, x - gap - WIDTH) : x + gap;
  const top = y + HEIGHT > bounds.height ? Math.max(8, Math.min(y - HEIGHT, bounds.height - HEIGHT - 8)) : Math.max(8, y - 14);
  return { left, top, transformOrigin: left < x ? 'top right' : 'top left' };
}

export interface Shape {
  x: number;
  y: number;
  width?: number;
  height?: number;
}

export interface MediaPin extends Shape {
  id: string;
  number: number;
  status: CommentStatus;
}

/** Pull the on-media position out of a point, region or time anchor. */
export function shapeOf(comment: Comment): Shape | null {
  const a = comment.anchor;
  if (a.type === 'point') return { x: a.x, y: a.y };
  if (a.type === 'region') return { x: a.x, y: a.y, width: a.width, height: a.height };
  if (a.type === 'time' && typeof a.x === 'number' && typeof a.y === 'number') {
    return typeof a.width === 'number' && typeof a.height === 'number' ? { x: a.x, y: a.y, width: a.width, height: a.height } : { x: a.x, y: a.y };
  }
  return null;
}
